import useLocalize from './useLocalize';

/**
 * Outputs the Translate function to localize the content.
 * @see https://github.com/ryandrewjohnson/react-localize-redux
 */
export default function useGetTranslate() {
  return useLocalize().translate;
}
